module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xzccsC/tc-custom/9781488097331.jpg?1704481969578",
      "alt": "This image is the cover for the book Red Rose for Love"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Red Rose for Love\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("Read this classic romance by ")]), _vm._v("USA Today"), _c('i', [_vm._v(" bestselling author Carole Mortimer, now available for the first time in e-book!")]), _c('br'), _c('br'), _c('b', [_vm._v("Can she trust the millionaire?")]), _c('br'), _c('br'), _vm._v("Eve had survived a horrendous ordeal with her ex, but the experience has left her a changed woman. Now her trusting young heart is safely buried. Never again will she love—least of all a rich man who thought his money could buy him everything, including her."), _c('br'), _c('br'), _vm._v("So, despite his persistence, charming businessman Bart Jordan doesn’t stand a chance with Eve. She may be allowing stubborn bitterness and fear to ruin her life, but can she ever trust a wealthy man again…?"), _c('br'), _c('br'), _c('i', [_vm._v("Originally published in 1982")]), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carole Mortimer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Carole Mortimer was born in England, the youngest of three children. She began writing in 1978, and has now written over one hundred and seventy books for Harlequin Mills and Boon®. Carole has six sons, Matthew, Joshua, Timothy, Michael, David and Peter. She says, ‘I’m happily married to Peter senior; we’re best friends as well as lovers, which is probably the best recipe for a successful relationship. We live in a lovely part of England.’")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises Limited\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0